// extracted by mini-css-extract-plugin
module.exports = {"background":"LandingPage_background__2-8Xm","showcase":"LandingPage_showcase__1kLCy"};